import { useQuery } from '@tanstack/react-query';
import { auth } from '../config/firebase';

export interface Brand {
  id: string;
  name: string;
  description: string;
  logo: string;
  website: string;
  industryId: string;
  values: string[];
  keywords: string[];
  languages: string[];
  members: {
    id: string;
    email: string;
    role: string;
    status: string;
    addedAt: string;
    updatedAt: string;
  }[];
  social_accounts: {
    accountId: string;
    platform: string;
    pageId: string;
    username?: string;
    picture_url?: string;
    name?: string;
    followers_count?: number;
    is_verified?: boolean;
  }[];
}

export interface BrandsResponse {
  success: boolean;
  brands: Brand[];
  pagination: {
    limit: number;
    offset: number;
    total: number;
  };
  // Maximum number of brands allowed for the current workspace/account
  // Provided at the root level by GET /management/brands
  brandsLimit?: number; // preferred
  brandLimits?: number; // legacy/alternate spelling from backend
}

export const useBrands = () => {
  return useQuery<BrandsResponse>({
    queryKey: ['brands'],
    staleTime: 30 * 1000, // Cache for 30 seconds
    gcTime: 60 * 1000, // Keep in cache for 1 minute (renamed from cacheTime)
    queryFn: async () => {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch('https://api.socialness.ai/management/brands', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch brands');
      }

      return response.json();
    }
  });
};